import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.scss']
})
export class VersionHistoryComponent {
  @Input() historyData ;
  @Input() attachment;
  @Output() downloadHistory = new EventEmitter()
  constructor() { }

  downloadVersionTemplate(history) {
    let data ={'attachment' : this.attachment, 'version': history.version}
    this.downloadHistory.emit(data);
  }
  formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 B'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

}
